import styles from './BecomePartners.module.css';
import BecomePartnerIcon from '/123123.webp';
import PlusIcon from '/NotificationsIcons/closeCross.svg';

interface BecomePartnersProps {
  type: 'partners' | 'sponsors';
  handleBecomePartner: () => void;
  style?: React.CSSProperties;
}

export const BecomePartners: React.FC<BecomePartnersProps> = ({ type, handleBecomePartner, style }) => {
  return (
    <div className={styles.become_partner_btn} onClick={handleBecomePartner} style={style}>
    <svg width="100%" height="100%" fill="none" preserveAspectRatio='none'>
    <rect x="0" y="0" vector-effect='non-scaling-stroke' width="100%" height="100%" rx="16" stroke="black"/>
    </svg>
    <div className={styles.become_partner_btn_content}>
    <div className={styles.become_partner_btn_content_icon}>
        <img src={BecomePartnerIcon} alt="partners" />
    </div>
    <div className={styles.become_partner_btn_content_text_container}>
        <div className={styles.become_partner_btn_content_title}>
        {type === 'partners' ? 'Стань партнером Dreamcoin' : 'Стань спонсором в Dreamcoin'}
        </div>
        <div className={styles.become_partner_btn_content_description}>
        Размести свой проект
        </div>
    </div>
    </div>
    <div className={styles.become_partner_btn_plus}>
    <img src={PlusIcon} alt="plus" />
    </div>
    </div>
  );
};
